import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph, 
    Button,
    CorrespondenceAddressComponent,
    ErrorMark
} from '../../components/RegularComponents'
import CheckboxForm from '../../components/CheckBoxForm'
import TopNavigationBar from "../TopNavigationBar"
import { useState } from 'react';
import { suretyBondSelect } from '../../redux/selector/suretyBondSelector';
import {replaceUrlParams} from '../../app/utils'
import Navigation from '../Navigation';
import { ERROR_STRING } from '../../app/errors';

const SuretyBond = (props) => {
    const {suretyBond} = props
    const {applicationType, applicationMode} = props.match.params
    const [showValidationError, setShowValidationError] = useState(false)
    
    const [suretyBondSelection, setSuretyBondSelection] = useState(suretyBond.confirmSuretyBond)

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
                <TopNavigationBar {...props} />
                <div className="row">
                    <div className="col-lg-8">
                        <Header header = {suretyBond.header} />
                        <Paragraph text = {suretyBond.text} />
                    </div>
                </div>
                {CorrespondenceAddressComponent()}
                <div className="row bottomMarginNormal">
                    <div className="col-lg-8">
                        <CheckboxForm 
                            id="surety-bond-checkbox"
                            checked={suretyBondSelection}
                            value={suretyBondSelection}
                            labelText="Yes, I confirm"
                            onCheckBoxChange={(val) => {
                                setShowValidationError(false)
                                setSuretyBondSelection(val)
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className={"col-lg-4"  + (showValidationError ? " has-error" : "")}>
                        <Button
                            id="surety-bond-save-next-button"
                            buttonType={"regular_primary"}
                            text={"Save and Next"}
                            onClick={() => {
                                if(!suretyBondSelection) { 
                                    setShowValidationError(true)
                                    return
                                }
                                setShowValidationError(false)
                                props.dispatch(push(replaceUrlParams(suretyBond.navigation.next,applicationType, applicationMode)))
                            }}
                        />
                        {showValidationError && ErrorMark()}
                        {showValidationError && 
                        <div className="ns-error-message help-block">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.SURETY_BOND_CONFIMRATION_NOT_CHECKED}
                        </div>}
                    </div>
                
            </div>
            </div>
        </>
    )
}

export default connect(suretyBondSelect)(SuretyBond)
